import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOfferSocket, extendedAuction, getConeccted, disconnected } from 'slices/offersSocketSlice';
import io from 'socket.io-client';
import { API_SOCKET } from './constants/Constants';

const connectSocketServer = () => {
  const dispatch = useDispatch();
  const { connected } = useSelector((state) => state.offersSocket);
  const url = API_SOCKET;
  let socket;
  if (!connected) {
    socket = io.connect(url);
    dispatch(getConeccted());
  }
  return socket;
};

const SocketConnection = () => {
  const dispatch = useDispatch();

  const [socket] = useState(connectSocketServer());
  const [online, setOnline] = useState(false);

  useEffect(() => {
    socket.on('connect', () => {
      setOnline(true);
    });
    return () => {
      socket.disconnect();
      dispatch(disconnected());
    };
  }, []);

  useEffect(() => {
    socket.on('offer-event', (data) => {
      dispatch(getOfferSocket(data));
    });
    return () => socket.disconnect();
  }, [socket]);

  useEffect(() => {
    socket.on('auction-status', (data) => {
      dispatch(extendedAuction(data));
    });
    return () => socket.disconnect();
  }, [socket]);

  return (
    <div className="d-none">{online}</div>
  );
};

export default SocketConnection;
